import { ApiError, NetworkError } from '@core/api/client'
import type { MeResponse } from '@core/api/auth'
import type { AuthState } from './useAuth'

/** O estado de autenticação que corresponde a cada resposta de
 *  /api/auth/me. Puro, para se testar sem React. */

export const cleared: Omit<AuthState, 'mode'> = {
  user: null,
  workspace: null,
  modules: [],
  hasPassword: false,
  aviso: null,
}

/** O estado que corresponde a uma resposta de /api/auth/me. */
export function estadoDoArranque(
  resultado: { me: MeResponse } | { erro: unknown },
): AuthState {
  if ('me' in resultado) {
    const me = resultado.me
    return {
      mode: 'cloud',
      user: me.user,
      workspace: me.workspace,
      modules: me.modules,
      partilhados: me.partilhados ?? {},
      hasPassword: me.has_password,
      aviso: null,
    }
  }
  const err = resultado.erro
  if (err instanceof NetworkError) return { mode: 'local', ...cleared }
  if (err instanceof ApiError && err.isUnauthorized) {
    return { mode: 'unauthenticated', ...cleared }
  }
  // 403: o servidor sabe quem é e recusa (workspace arquivado). Não é
  // "servidor ausente": entrar em modo local escondia o motivo.
  if (err instanceof ApiError && err.status === 403) {
    return { mode: 'forbidden', ...cleared, aviso: err.message }
  }
  // 5xx ou resposta ilegível: o servidor existe mas falhou. Mostra-se
  // e deixa-se tentar outra vez (ou seguir em modo local, à escolha).
  return { mode: 'server-error', ...cleared }
}

